<template>
    <el-card class="box-card">

        <el-card>
            <el-form :inline="true" label-suffix=":">
                <el-form-item label='游戏服'>
                    <component-server @oneGameServer="getGameValue":serverMode="'mode__one_game'"></component-server>
                </el-form-item>
                <el-form-item label='排行榜'>
                    <el-select v-model="selectGameMode">
                        <el-option :key="index"
                                   v-for="(gameModeOption,index) in gameModeOptions"
                                   :label="gameModeOption.lang + '(' + gameModeOption.id + ')'"
                                   :value="gameModeOption.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label='主城节点' v-if="selectGameMode == 'COMPETE'">
                    <el-select v-model="selectMapNodeId">
                        <el-option :key="index"
                                   v-for="(mapNodeItem,index) in mapNodeConfig"
                                   :label="mapNodeItem.id + '(' + $t(mapNodeItem.name) + ')'"
                                   :value="mapNodeItem.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='世界之王' v-if="selectGameMode == 'WORLD_BOSS'">
                    <el-select v-model="selectWorldBossId">
                        <el-option :key="index"
                                   v-for="(worldBossItem,index) in worldBossConfig"
                                   :label="worldBossItem.id + '(' + $t(worldBossItem.name) + ')'"
                                   :value="worldBossItem.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="getRankings">查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>

      <el-table :data="rankings" border style="width: 100%"
                :default-sort="{prop: 'id'}">
        <el-table-column v-for="(header,index) in tableHeaders" :label="header.text"
                         :prop="header.text"
                         :key="index" width="150">
          <template slot-scope="scope">
            <span v-for="(value,key) in scope.row" v-if="key == header.text">{{value}}</span>
          </template>
        </el-table-column>
          <el-table-column label="处理" width="150">
              <template slot-scope="scope">
                  <el-button type="text" @click="clearRanking(scope.row)">信息清理</el-button>
              </template>
          </el-table-column>
      </el-table>
    </el-card>
</template>

<script>
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import gameApi from '../../service/game_api'
    import configSettingApi from '../../service/config_setting_api'
    import componentServer from '../../components/component_server'
    import Utils from '../../lib/utils'
    import commonApi from "../../service/common_api";

    export default {
        name: "query_ranking",
        data () {
            return {
                gameModeOptions:[
                    {
                        "id": "HUNTING",
                        "lang": "狩猎"
                    },
                    {
                        "id": "WORLD_BOSS",
                        "lang": "世界灾厄"
                    },
                    {
                        "id": "COMPETE",
                        "lang": "斗技场"
                    },
                    {
                        "id": "HALL",
                        "lang": "起源殿"
                    },
                    {
                        "id":"MYSTERY_LAIR",
                        "lang": "暴走旷野"
                    },
                    {
                        "id": "TRACE",
                        "lang": "凿星裂痕"
                    },
                    {
                        "id": "TRIBE_KING",
                        "lang": "部落之王"
                    },
                    {
                        "id": "ACTIVITY_ONE_COIN_PASSED",
                        "lang": "一创到底"
                    },
                    {
                        "id": "ACTIVITY_TINY_GAME1",
                        "lang": "拼二大作战"
                    },
                    {
                        "id": "ACTIVITY_PALM_SLAP",
                        "lang": "天降一掌"
                    },
                    {
                        "id": "ACTIVITY_FIGHT_HARM",
                        "lang": "合围破阵"
                    },
                    {
                        "id": "ACTIVITY_FIGHT_KILLED",
                        "lang": "突围鏖战"
                    }
                ],
                selectGameMode:'HUNTING',
                selectMapNodeId:-1,
                selectWorldBossId:-1,
                // 已选游戏服数据
                gameUri: '',
                gameServer: '',
                rankings:[],
                // 动态表头
                tableHeaders: [],
                mapNodeConfig:[],
                worldBossConfig:[],
            }
        },
        mixins: [actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList,
            }),
        },
      created() {
            this.loadSelectedConfig();

      },
      mounted() {
        },
        methods: {
            getGameValue(uri,serverId) {
                this.gameServer = serverId;
                this.gameUri= uri;
            },
            loadSelectedConfig(){
                let self = this;
                commonApi.getConfs({
                    tables: 'map_node,world_boss_config'
                }).then(res => {
                    console.log(res);
                    self.mapNodeConfig = [];
                    res.map_node.forEach(item=>{
                        if (item.type == 3){
                            self.mapNodeConfig.push(item);
                        }
                    })

                    self.worldBossConfig = res.world_boss_config;

                })
            },
            getRankings(){
                let self = this;
                let refId = -1;
                if (this.selectGameMode == 'COMPETE'){
                    refId = self.selectMapNodeId;
                }
                else if (this.selectGameMode == 'WORLD_BOSS'){
                    refId = self.selectWorldBossId;
                }

                gameApi.rankingInfo({
                    token:this.token,
                    rankingForm: {
                        uri: this.gameUri,
                        server: this.gameServer,
                        gameMode: this.selectGameMode,
                        refId:refId
                    }
                }).then(res=>{
                  this.rankings = res.content.rankings;
                  this.tableHeaders = [];
                  for (var i in this.rankings[0]) {
                    this.tableHeaders.push({
                      text: i
                    });
                  }
                })

            },
            clearRanking(rowData){
                let self = this;
                let refId = -1;
                if (this.selectGameMode == 'COMPETE'){
                    refId = self.selectMapNodeId;
                }
                else if (this.selectGameMode == 'WORLD_BOSS'){
                    refId = self.selectWorldBossId;
                }
                gameApi.clearRanking({
                    token:this.token,
                    rankingForm: {
                        uri: this.gameUri,
                        server: this.gameServer,
                        gameMode: this.selectGameMode,
                        refId:refId,
                        ids:rowData.id+''
                    }
                }).then(res=>{
                    console.log(res);
                })
            }

        },
        components: {
            componentServer
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/players/query_ranking.vue